<template>
  <section>
    <h2>{{ heading }}</h2>
    <div class="row">

      <div class="full">

        <div v-if="!isServiceLoaded">
          <progress-ring radius="60" :progress="servicesProgress" stroke="4"></progress-ring>
        </div>

        <div class="envn" v-if="isServiceLoaded">



          <table v-if="services.length">
            <tr v-for="service in filtered_by" @click="goToService(service.id)">
              <td class="srv-name">{{ service.serviceName }}</td>
              <td class="srv-impact">Has {{ service.knownImpacts.length }} impacts</td>
              <td class="srv-uptime">{{ service.errorBudget }} error budget</td>
              <td :class="'srv-fail-' + service.safeToFail"> Is <strong v-if="!service.safeToFail">not</strong> safe to fail</td>
            </tr>
          </table>

          <div class="row" style="margin-top:20px;">
            <div class="fifty">

            </div>
            <div class="fifty">
              <router-link to="/services/create" tag="button">Add a service</router-link>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { RepositoryFactory } from '@/services/repositoryfactory'
const ServiceRepository = RepositoryFactory.get('services');
import ProgressRing from '@/components/progress-ring.vue'

export default {
  name: 'ServiceHome',
  components: {
    ProgressRing
  },
  data () {
    return {
      isServiceLoaded: false,
      services: null,
      specs: null,
      servicesProgress: 0,
      heading: "Services",
      serviceVisualisation: []
    }
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.getServices();
    },

    async getServices() {
      const interval = setInterval(() => {
        this.specsProgress += 1;
        if (this.specsProgress === 100)
          clearInterval(interval);
      }, 100);

      this.services = await ServiceRepository.getAllServices();
      this.isServiceLoaded = true;
      // this.createVisualisation()
    },

    goToService(id) {
      this.$router.push({ name: 'service-view', params: { serviceid: id } });
    },

    createVisualisation() {
      for (const service in this.services) {
        var temp = { "name":"", "imports":[] };
        temp.name = this.services[service].serviceName;

        if(this.services[service].knownImpacts.length) {
          for (const impact in this.services[service].knownImpacts) {
            temp.imports.push(this.services[service].knownImpacts[impact].serviceName)
          }
        }

        this.serviceVisualisation.push(temp);
      }
    }

  },
  computed: {
    filtered_by() {
      if(!this.$route.query.environment && !this.$route.query.compliance) { return this.services }
      var result = [];

      // Environment
      if(this.$route.query.environment) {
        result = this.services.filter(service => service.environment[this.$route.query.environment] == true);
        this.heading = `Services filtered by "${this.$route.query.environment}" environment`
      }

      // Compliance
      if(this.$route.query.compliance) {
        result = this.services.filter(service => service.dataCompliance[this.$route.query.compliance] == true);
        this.heading = `Services filtered by "${this.$route.query.compliance}" data compliance`
      }

      return result;
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    date: function(cdate) {
      if (!cdate) return '';
      var d = new Date(parseInt(cdate));
      return d.toDateString();
    }
  }
}
</script>
